module.exports = __webpack_public_path__ + "img/r3.b95576b2.png";